var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VSelect',_vm._g(_vm._b({attrs:{"label":"Proje","items":_vm.projects,"item-text":"name","item-value":"id","hide-details":"auto","clearable":!_vm.$attrs.required}},'VSelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }